<template>
  <f7-popup class="billing-popup">
    <f7-page
      no-toolbar
      no-navbar
      no-swipeback
    >
      <a
        class="fixed top-0 right-0 m-5 rounded-full shadow-lg p-2 leading-3 bg-purple-500 z-10"
        @click="closePopup()"
      >
        <eva-icon
          name="close-outline"
          fill="#FFFFFF"
          width="32"
          height="32"
        />
      </a>
      <div
        class="p-10 pt-16 z-0"
      >
        <credit-card-form
          :planID="planID"
          :quantity="quantity"
          @close="closePopup"
        />
      </div>
    </f7-page>
  </f7-popup>
</template>
<script>
import { mapState } from 'vuex'
import { f7Popup } from 'framework7-vue'
import creditCardForm from '../components/creditCardForm'

export default {
  name: 'BillingPopup',
  components: {
    f7Popup,
    creditCardForm,
  },
  props: {
    planID: { default: '', type: String },
    quantity: { default: 0, type: Number },
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState({
    }),
  },
  watch: {
  },
  async mounted () {
  },
  methods: {
    closePopup () {
      this.$f7router.back()
    },
  },
}
</script>
<style lang="scss" scoped>
@import "../css/_brand";
</style>
